import {
    useCallback,
} from 'react'

import StatusHandler from 'app/shared-components/StatusHandler'

import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'
import useGetAQuote from '../hooks/useGetAQuote'

import AQuoteUpdate from './AQuoteUpdate'

const AQuoteUpdateContainer = ({
    id,
}: { id: number }) => {
    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
        invalidate,
    } = useGetAQuote(id)
    const {
        AQuotes: AQuotesRoutes,
    } = useAccountManagementRoutes()

    const onSuccess = useCallback(() => {
        AQuotesRoutes.Overview.navigate({
            params: {
                key: data?.id,
            },
        })

        invalidate()
    }, [
        invalidate,
        AQuotesRoutes.Overview,
        data?.id,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <AQuoteUpdate
                data={data}
                onSuccess={onSuccess}
                onCancel={invalidate}
            />
        </StatusHandler>
    )
}

export default AQuoteUpdateContainer
